import React from 'react'
import Select, { StylesConfig, ActionMeta, SingleValue } from 'react-select'
import styles from './CustomSelect.module.css'
import { useMediaQuery } from 'react-responsive'

type OptionType = {
  value: string
  label: string
}

type CustomSelectProps = {
  options?: string[] | OptionType[]
  onChangeOption?: (option: string) => void
  value?: string
  placeholder?: string
  className?: string
  isDisabled?: boolean
  name?: string
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options = [],
  onChangeOption,
  value = '',
  placeholder = 'Выберите...',
  className = '',
  isDisabled = false,
  name = '',
}) => {
  const normalizedOptions = options.map((option) =>
    typeof option === 'string' ? { value: option, label: option } : option,
  )

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const customStyles: StylesConfig<OptionType, false> = {
    control: (provided) => ({
      ...provided,
      border: 'none',
      boxShadow: 'none',
      minHeight: 'auto',
      backgroundColor: 'transparent',
    }),
    menu: (provided) => ({
      ...provided,
      right: 0,
      overflow: 'auto',
      height: '150px',
    }),
    menuList: (provided) => ({
      fontSize: 12,
      ...provided,
      maxHeight: '150px',
      overflowY: 'auto',
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      height: isMobile ? 44 : 24,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: 0,
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: 0,
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  }

  const handleChange = (newValue: SingleValue<OptionType>, actionMeta: ActionMeta<OptionType>) => {
    if (onChangeOption && newValue) {
      onChangeOption(newValue.value)
    }
  }

  const selectedOption = normalizedOptions.find((option) => option.value === value) || null

  return (
    <div className={`${styles.reactSelect} ${className}`}>
      <Select
        name={name}
        options={normalizedOptions}
        onChange={handleChange}
        value={selectedOption}
        placeholder={placeholder}
        styles={customStyles}
        isDisabled={isDisabled}
        menuPortalTarget={document.body}
        menuPosition='fixed'
      />
    </div>
  )
}

export default CustomSelect
